enum StorageKey {
    LOGGED_USER = "LOGGED_USER",
    USER = "USER",
    SIDEBAR = "SIDEBAR",
    APP_CONFIG = "APP_CONFIG",
    COMPANY_BOOK = "COMPANY_BOOK",
    COMPANY_LOCATION = "COMPANY_LOCATION",
}

export default StorageKey
